import React from "react";
import TrendingCollection from "../../../components/_home/TrendingCollection/TrendingCollection";
import { trending } from "../../../mock/trending";
import Slider from "react-slick";
import styles from "./Trending.module.scss";

const Trending = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 7.2,
    slidesToScroll: 7.2,
    responsive: [
      {
        breakpoint: 1580,
        settings: {
          slidesToShow: 6.2,
          slidesToScroll: 6.2,
        },
      },
      {
        breakpoint: 1320,
        settings: {
          slidesToShow: 5.2,
          slidesToScroll: 5.2,
        },
      },
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 4.2,
          slidesToScroll: 4.2,
        },
      },
      {
        breakpoint: 950,
        settings: {
          slidesToShow: 3.6,
          slidesToScroll: 3.6,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2.8,
          slidesToScroll: 2.8,
        },
      },
      {
        breakpoint: 615,
        settings: {
          slidesToShow: 2.2,
          slidesToScroll: 2.2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2.1,
          slidesToScroll: 2.1,
        },
      },
      {
        breakpoint: 450,
        settings: {
          slidesToShow: 1.9,
          slidesToScroll: 1.9,
        },
      },
      {
        breakpoint: 420,
        settings: {
          slidesToShow: 1.6,
          slidesToScroll: 1.6,
        },
      },
    ],
  };
  return (
    <section className={styles.container}>
      <div className={styles.subContainer}>
        <h1>Trending Collections</h1>
        <p>Last 7 days</p>

        <div className={styles.cardsContainer}>
          <Slider {...settings}>
            {trending.map((i) => (
              <TrendingCollection
                key={i.id}
                name={i.name}
                img={i.img}
                price={i.price}
                blockchain={i.blockchain}
                percentage={i.percentage}
              />
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default Trending;
